import React, { useState, useEffect, useContext, useRef } from 'react';

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext'
import { Calendar } from 'primereact/calendar';
import { Checkbox } from 'primereact/checkbox'
import { Dropdown } from 'primereact/dropdown'
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

// ------------------ COMPONENTES DE BASE--------------------------
import Card from '../../../Base/Components/Card/Card';
import { toastShow } from '../../../Base/Services/ToastService';
import { useForm } from '../../../Base/Hooks/useForm'
import AgGrid from '../../../Base/Components/Tables/AgGrid/AgGrid';
import Loader from '../../../Base/Components/Loader/Loader';
import { getLabel } from '../../../Base/Services/Language/LanguageService';
import { AuthContext } from '../../../Base/Context/AuthContext/AuthContext';
import { ConfigContext } from '../../../Base/Context/ConfigContext/ConfigContext';

// ------------------- CONSULTAS A LA API---------------------------
import { getCartasCredito, getOrdenVenta, getOrdenVentasDetalles, postEstilosCartaCredito } from '../../../API/Ventas/SalesOrderRequest';

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import { OrdenesVentasLang } from './OrdenesVentasLang';

import { getPCsByIdSOD } from '../../../API/Produccion/ProductionCard/ProductionCardRequests';
import TrackingLot from '../../Produccion/TrakingLot/TrackingLotScreen';
import { setMasterWipClosingControl } from '../../../API/Planning/MasterWip/MasterWipRequest';


const SalesOrdersCRUD = ({ dialogSO, hideDialog, IdSalesOrder }) => {
    const toast = useRef(null)
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({})
    const [listadoDetalles, setListadoDetalles] = useState([]);
    const [detallePC, setDetallePC] = useState([]);
    const [cartasCredito, setCartasCredito] = useState([])
    const { config } = useContext(ConfigContext);
    const { userAuth } = useContext(AuthContext);
    const [rowIndex, setRowIndex] = useState(-1);
    const [showPC, setShowPC] = useState(null);
    const [selected, setSelected] = useState([]);

    const { values, setValues, handleChange, handleInputChange, resetForm } = useForm({

    });


    const ObtenerInformacion = async () => {
        setLoading(true)
        const tempoEnc = await getOrdenVenta(IdSalesOrder)
        if (tempoEnc?.length > 0) {
            let IdCliente = tempoEnc[0]?.IdCustomer
            const tempoCartas = await getCartasCredito(IdCliente)
            setCartasCredito(tempoCartas)
            setValues(tempoEnc[0])
            const tempoDetalles = await getOrdenVentasDetalles(IdSalesOrder)
            // if(tempoDetalles?.length > 0){
            //     setRowIndex(0)
            // }else{
            // }
            setRowIndex(-1)
            setListadoDetalles(tempoDetalles)
            setDetallePC([])
            setSelected([])

        }
        setLoading(false)
    }

    const changeCheckClosing = async (e, { data }, SubFuncion) => {
        setLoading(true);
        let changes = [data];
        if(selected.length > 0){
            changes = selected
        }

        changes.forEach(async(e) => {
            let data = e
            let IdSalesOrderDetail = data?.IdSalesOrderDetail
            if (IdSalesOrderDetail) {
                let a = await setMasterWipClosingControl(
                    {
                        IdSalesOrderDetail,
                        SubFuncion,
                        Check: !(SubFuncion === 1 ? data.CerradoVentas : data.CerradoPlanning),
                    })
                console.log(a);
            }
        })
        setLoading(false);
        ObtenerInformacion()

    }

    const GuardarInformacion = async () => {
        listadoDetalles.forEach((e) => {
            e.IdUserEdit = userAuth.idUser
        })

        let datosEnviar = {
            Data: values,
            Detalles: listadoDetalles
        }
        const result = await postEstilosCartaCredito(datosEnviar)
        if (result) {
            toastShow(toast, 'success', 'Guardada', 'Información Guardada Exitosamente')
            ObtenerInformacion()
        } else {
            toastShow(toast, 'error', 'Error', 'Ocurrio un error al guardar la información')
        }

    }

    const getPCColors = async (e, data) => {
        if (e.rowIndex !== rowIndex) {
            setRowIndex(e.rowIndex);
            if (data.IdSalesOrderDetail) {
                const a = await getPCsByIdSOD(data.IdSalesOrderDetail);
                setDetallePC(a);
            }
        }
    }

    const formatPC = (e, d) => {
        let PC
        // // console.log(e);
        if (e["Tarjeta Produccion"]) {

            const value = e["Tarjeta Produccion"];

            if (value.length > 8 && !value.includes('-')) { // si el valor es mayor a 8 y no contiene un -
                let tempo = value.substring(0, 8) + '-' + value.substring(8, 11) + '-' + value.substring(11, value.length);
                // console.log(tempo);
                PC = tempo;
            } else {
                if (e.nativeEvent.data) { // SI NO ES UN DELETE
                    if (value.length <= 15) { // SI EL VALOR ES MENOR A 15
                        if ([8, 12].includes(value.length)) { // AGREGA GUIONES DEPUES DE LA POSICION 8 Y 12
                            PC = value + '-';
                        } else {
                            PC = value;
                        }
                    }
                } else {
                    PC = value;
                }
            }
        }

        return PC;
    }

    const colums = [
        {
            field: "IdSalesOrderDetail",
            header: "ID",
            headerEn: "ID",
            hidden: userAuth.IdRol === 1,
            className: "Xsmall",
        },
        {
            field: 'FechaCreada',
            header: 'Fecha Creada',
            headerEn: 'Create Date',
            className: 'small',
            Format: 'Date',
        },
        {
            field: 'RequiereTejido',
            header: 'Tejido',
            headerEn: '',
            className: 'small',
            Format: 'Checkbox',
        },

        {
            field: 'OrderType',
            header: 'Tipo Orden',
            headerEn: 'OrderType',
            className: 'small',
        },
        {
            field: 'StyleCode',
            header: 'StyleCode',
            headerEn: '',
            className: 'small',
            width: 100,
            Frozen: true,
            alignFrozen: 'left',
        },
        {
            field: 'Style',
            header: 'Estilo',
            headerEn: 'StylesName',
            className: 'large',
            Frozen: true,
            alignFrozen: 'left',
        },
        {
            field: 'Weight',
            header: 'Weight',
            headerEn: '',
            width: 60,
            className: 'Xsmall',
            Format: 'Currency',
            Frozen: true,
            alignFrozen: 'left',
        },
        {
            field: 'ColorName',
            header: 'Color',
            headerEn: 'Color',
            className: 'medium',
            Sumary: 'count',
            Frozen: true,
            alignFrozen: 'left',
        },
        {
            field: 'Width',
            header: 'Width',
            headerEn: 'Width',
            className: 'XXsmall',
            width: 60,
            Format: 'Currency',
            Frozen: true,
            alignFrozen: 'left',
        },
        {
            field: 'LabDip',
            header: 'Receta',
            headerEn: 'LabDip',
            className: 'medium',
        },
        {
            field: 'CategoriaDensidad',
            header: 'Color Category',
            headerEn: 'CategoriaDensidad',
            className: 'Xsmall',
        },

        // {
        //     field: 'EstiloCarta',
        //     header: 'Estilo Carta Crédito',
        //     headerEn: 'Cart Style',
        //     className: 'XXXlarge',
        //     editable: true
        // },       
        //  {
        //     field: 'Piezas',
        //     header: 'Pieces',
        //     headerEn: 'Pieces',
        //     className: 'Xsmall',
        //     Sumary: 'sum',
        //     Format: 'Currency',
        //     Frozen: true,
        //     alignFrozen: 'right'
        // },
        {
            field: 'UnitName',
            header: 'Unidad',
            headerEn: 'UnitName',
            className: 'Xsmall',
        },
        {
            field: 'BuyerFabricCode',
            header: 'Buyer Fabric Code',
            headerEn: 'BuyerFabricCode',
            className: 'small',
        },
        {
            field: 'BuyerStyle',
            header: 'Buyer Style',
            headerEn: 'BuyerStyle',
            className: '',
        },
        {
            field: 'Season',
            header: 'Season',
            headerEn: 'Season',
            className: 'Xsmall',
        },
        {
            field: 'FechaRequerida',
            header: 'Fecha Requerida',
            headerEn: 'Required Date',
            className: 'small',
            Format: 'Date',
        },
        {
            field: 'PlanExportDateWeb',
            header: 'Fecha Exportacion',
            headerEn: 'Required Date',
            className: 'small',
            Format: 'Date',
        },
        {
            field: 'Comments',
            header: 'Comments',
            headerEn: 'Comments',
            className: 'medium',
        },
        {
            field: 'GYA',
            header: 'GYA',
            headerEn: 'GYA',
            className: 'Xsmall',
            Format: 'Currency',
        },
        {
            field: 'GYT',
            header: 'GYT',
            headerEn: 'GYT',
            className: 'Xsmall',
            Format: 'Currency',
        },
        {
            field: 'KCDescription',
            header: 'Condición Tejido',
            headerEn: 'KCDescription',
            className: 'XXlarge',
        },
        {
            field: 'Yarns',
            header: 'Yarns',
            headerEn: 'Yarns',
            className: 'XXlarge',
        },

        {
            field: 'CustomerPO',
            header: 'Cliente PO',
            headerEn: 'CustomerPO',
            className: 'small',
        },
        {
            field: 'IdWorkflow',
            header: 'Ruta',
            headerEn: 'Workflow',
            className: 'XXlarge',
        },
        {
            field: 'ItemNumber',
            header: 'Item',
            headerEn: 'Item',
            className: 'XXsmall',
            Format: 'Center',
        },
        {
            field: 'OrderType',
            header: 'OrderType',
            headerEn: 'OrderType',
            className: 'small',
            // Format: 'Currency',
        },

        {
            field: 'KgsAcabado',
            header: 'Kint Kgs',
            headerEn: 'Kint Kgs',
            className: 'Xsmall',
            Format: 'Currency',
            Sumary: 'sum',
        },
        {
            field: 'YdsAcabado',
            header: 'Kint Yds',
            headerEn: 'Kint Yds',
            className: 'Xsmall',
            Format: 'Currency',
            Sumary: 'sum',
        },

        {
            field: 'Piezas',
            header: 'Pieces',
            headerEn: 'Pieces',
            className: 'Xsmall',
            Sumary: 'sum',
            Format: 'Currency',
            // Frozen: true,
            // alignFrozen: 'right'
        },
        {
            field: 'GeneralQty',
            header: 'Qty',
            headerEn: 'Qty',
            className: 'Xsmall',
            Format: 'Currency',
            Sumary: 'sum',
            // Frozen: true,
            // alignFrozen: 'right'
        },


        {
            field: 'LbsQtyWL',
            header: 'Lbs',
            headerEn: 'Lbs',
            className: 'Xsmall',
            Format: 'Currency',
            Sumary: 'sum',
            // Frozen: true,
            // alignFrozen: 'right'
        },
        {
            field: 'UnitPrice',
            header: 'Precio',
            headerEn: 'Price',
            className: 'Xsmall',
            Format: 'Decimal',
            // Frozen: true,
            // alignFrozen: 'right',
        },
        {
            field: 'Subtotal',
            header: 'SubTotal',
            headerEn: 'SubTotal',
            className: 'Xsmall',
            Format: 'Currency',
            Sumary: 'sum',
            // Frozen: true,
            // alignFrozen: 'right',
            hidden: [1, 6].includes(userAuth.IdRol)
        },
        // {
        //     field: 'ExportQty',
        //     header: 'Export Qty',
        //     headerEn: 'Price',
        //     className: 'Xsmall',
        //     Format: 'Decimal',
        //     Frozen: true,
        //     alignFrozen: 'right',
        // },
        {
            headerName: 'Closing Control',
            children: [
                {
                    field: 'CerradoVentas',
                    header: 'Ventas',
                    headerEn: '',
                    width: 70,
                    className: 'small',
                    Format: 'Checkbox',
                    Frozen: true,
                    alignFrozen: 'right',
                    onChange: (e, data) => changeCheckClosing(e, data, 1)
                },
                {
                    field: 'CerradoPlanning',
                    header: 'Planning',
                    headerEn: '',
                    width: 70,
                    className: 'small',
                    Format: 'Checkbox',
                    Frozen: true,
                    alignFrozen: 'right',
                    // onChange: (e, data) => changeCheckClosing(e, data, 2)
                },

            ]
        },
        {
            headerName: 'Orden',
            children: [
                {
                    field: 'KgsAcabado',
                    header: 'Kgs',
                    headerEn: 'Kgs',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                    Frozen: true,
                    alignFrozen: 'right'
                },
                {
                    field: 'YdsAcabado',
                    header: 'Yds',
                    headerEn: 'Yds',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                    Frozen: true,
                    alignFrozen: 'right'
                },
            ]
        },
        {
            headerName: 'Exported',
            children: [
                {
                    field: 'KgsEX',
                    header: 'Kgs',
                    headerEn: '',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                    Frozen: true,
                    alignFrozen: 'right',
                },
                {
                    field: 'YdsEX',
                    header: 'Yds',
                    headerEn: '',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                    Frozen: true,
                    alignFrozen: 'right',
                },

            ]
        },
    ]

    const table = {
        Data: listadoDetalles,
        Columns: colums,
        onCellFocused: getPCColors,
        selected: selected,
        setSelected: setSelected,
        // loading: loading,
    }

    const columsPC = [
        {
            field: 'Tarjeta Produccion',
            header: 'PC',
            headerEn: '',
            className: 'small',
            Frozen: true,
            alignFrozen: 'left',
            Format: 'Template',
            body: formatPC,
            onCellDoubleClicked: (e) => {
                if (e?.value) {
                    console.log(e.value);
                    setShowPC(e.value);
                }
            },
        },
        {
            field: 'ProType',
            header: 'ProType',
            headerEn: '',
            className: 'Xsmall',
            Sumary: 'count',
        },
        {
            field: 'Estado',
            header: 'Estado',
            headerEn: '',
            className: 'Xsmall',
        },
        {
            field: 'Subcategory',
            header: 'Subcategory',
            headerEn: '',
            className: 'Xsmall',
        },
        {
            field: 'DyeMachineD',
            header: 'DyeMachineD',
            headerEn: '',
            className: 'Xsmall',
        },
        {
            field: 'Porcentaje',
            header: '%',
            headerEn: '',
            className: 'Xsmall',
            // Format: 'Porcentaje',
        },
        {
            field: 'Weight',
            header: 'Weight',
            headerEn: '',
            className: 'Xsmall',
            Format: 'Currency',
        },
        {
            field: 'Width',
            header: 'Width',
            headerEn: '',
            className: 'Xsmall',
            Format: 'Center',
        },
        {
            headerName: 'Pedido',
            children: [
                {
                    field: 'WKg',
                    header: 'Kg',
                    headerEn: '',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'WYd',
                    header: 'Yd',
                    headerEn: '',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
            ],
        },
        {
            headerName: 'Carga Crudo',
            children: [
                {
                    field: 'GKg',
                    header: 'Kg',
                    headerEn: '',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'GYd',
                    header: 'Yd',
                    headerEn: '',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                },

            ]
        },
        {
            headerName: 'GG - Loss',
            children: [
                {
                    field: 'KgEsperados',
                    header: 'Kg',
                    headerEn: '',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'YdsEsperadas',
                    header: 'Yd',
                    headerEn: '',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                },

            ]
        },
        {
            headerName: 'Tintoreria',
            children: [
                {
                    field: 'Tinto(Kg)',
                    header: 'Kg',
                    headerEn: '',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'Tinto(Yd)',
                    header: 'Yd',
                    headerEn: '',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                },

            ]
        },
        {
            headerName: 'Acabado',
            children: [
                {
                    field: 'Acabado(Kg)',
                    header: 'Kg',
                    headerEn: '',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'Acabado(Yd)',
                    header: 'Yd',
                    headerEn: '',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                },

            ]
        },
        {
            headerName: 'Calidad A',
            children: [
                {
                    field: 'AcaG(Kg)',
                    header: 'Kg',
                    headerEn: '',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'AcaG(Yd)',
                    header: 'Yd',
                    headerEn: '',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                },

            ]
        },
        {
            headerName: 'Calidad B',
            children: [
                {
                    field: 'ACA_B(Kg)',
                    header: 'Kg',
                    headerEn: '',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'ACA_B(Yd)',
                    header: 'Yd',
                    headerEn: '',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                },

            ]
        },
        {
            headerName: 'Calidad C',
            children: [
                {
                    field: 'ACA_C(Kg)',
                    header: 'Kg',
                    headerEn: '',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'ACA_C(Yd)',
                    header: 'Yd',
                    headerEn: '',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                },

            ]
        },
        {
            headerName: 'Exportacion',
            children: [
                {
                    field: 'Exportado(Kg)',
                    header: 'Kg',
                    headerEn: '',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                    Frozen: true,
                    alignFrozen: 'right'
                },
                {
                    field: 'Exportado(Yd)',
                    header: 'Yd',
                    headerEn: '',
                    className: 'Xsmall',
                    Format: 'Currency',
                    Sumary: 'sum',
                    Frozen: true,
                    alignFrozen: 'right'
                },

            ]
        },
    ]

    const tablePC = {
        Data: detallePC,
        Columns: columsPC,
    }

    useEffect(() => {
        if (dialogSO) {
            ObtenerInformacion()
        } else {
            setData({})
            setListadoDetalles([])
        }
    }, [dialogSO])

    return (
        <Dialog visible={dialogSO} onHide={hideDialog} maximizable maximized closeOnEscape={false}
            header={<div className='d-flex flex-row'>
                <h3>{getLabel(OrdenesVentasLang, 'TituloOrden', config.language)}</h3>
            </div>}>
            <div>
                <TrackingLot showPC={showPC} setShowPC={setShowPC} />
                <Loader loading={loading} />
                <Toast ref={toast} />
                <div className='columns6 fromSlim' Id='SOCRUD' >
                    <div className='d-flex flex-column'>
                        <span className="p-float-label mt-2">
                            <InputText
                                value={values.SalesOrder}
                                onChange={(e) => handleInputChange(e, 'SalesOrder')}
                                style={{ width: '100%', fontWeight: 'bold' }}
                                disabled
                            />
                            <label htmlFor="in">{getLabel(OrdenesVentasLang, 'NoOrder', config.language)}</label>
                        </span>
                        <div className='d-flex'>
                            <span className="p-float-label mt-2 col-6" style={{ paddingTop: 11 }}>
                                <InputText
                                    value={values.StatusName}
                                    onChange={(e) => handleInputChange(e, 'CustomerOrder')}
                                    style={{ width: '100%' }}
                                    disabled
                                />
                                <label htmlFor="in">{getLabel(OrdenesVentasLang, 'Status', config.language)}</label>
                            </span>
                            <div className='col-6 center'>
                                <Card
                                    titulo={getLabel(OrdenesVentasLang, 'localOtros', config.language)}
                                    contenido={<div className='d-flex flex-row' style={{ justifyContent: 'center' }}>
                                        <Checkbox checked={values.LocalOtros} disabled />
                                    </div>}
                                />

                            </div>

                        </div>


                        <Card
                            titulo={getLabel(OrdenesVentasLang, 'Payment', config.language)}
                            contenido={<div >
                                <div className='columns2'>
                                    <label>Type: </label>
                                    <InputText
                                        value={values.TipoPagoN} disabled
                                        style={{ width: '90%' }} />

                                </div>
                                <div className='columns2'>
                                    <label>L/C:</label>
                                    <Dropdown
                                        value={values.IdCartaCredito}
                                        onChange={(e) => handleInputChange(e, 'IdCartaCredito')}
                                        options={cartasCredito}
                                        optionLabel='NumeroCartaCredito'
                                        optionValue='IdCartaCredito'
                                        filter filterBy='NumeroCartaCredito'
                                        disabled
                                        style={{ width: '90%' }} />
                                </div>
                            </div>}
                        />
                    </div>
                    <div className='d-flex flex-column' >
                        <span className="p-float-label mt-2">
                            <InputText
                                value={values.CustomerOrder}
                                onChange={(e) => handleInputChange(e, 'CustomerOrder')}
                                disabled
                                style={{ width: '100%' }}
                            />
                            <label htmlFor="in">{getLabel(OrdenesVentasLang, 'CustomerOrder', config.language)}</label>
                        </span>
                        <span className="p-float-label mt-2">
                            <InputText
                                value={values.CustomerName}
                                disabled
                                // onChange={(e) => handleInputChange(e, 'CustomerOrder')}
                                style={{ width: '100%' }}
                            />
                            <label htmlFor="in">{getLabel(OrdenesVentasLang, 'Customer', config.language)}</label>
                        </span>
                        <span className="p-float-label mt-2">
                            <InputText
                                value={values.CompanyName}
                                disabled
                                style={{ width: '100%' }}
                            />
                            <label htmlFor="in">{getLabel(OrdenesVentasLang, 'Buyer', config.language)}</label>
                        </span>
                        <span className="p-float-label mt-2">
                            <InputText
                                value={values.SalesAgent}
                                disabled
                                style={{ width: '100%' }}
                            />
                            <label htmlFor="in">{getLabel(OrdenesVentasLang, 'SalesAgent', config.language)}</label>
                        </span>

                    </div>
                    <div className='d-flex flex-column'>

                        <span className="p-float-label mt-2">
                            <InputText
                                value={values.CustomerServiceAgent}
                                disabled
                                // onChange={(e) => handleInputChange(e, 'AgenteVentas')}
                                style={{ width: '100%' }}
                            />
                            <label htmlFor="in">{getLabel(OrdenesVentasLang, 'CustomerServiceAgent', config.language)}</label>
                        </span>
                        <span className="p-float-label mt-2">
                            <InputText
                                value={values.orderAgent}
                                disabled
                                style={{ width: '100%' }}
                            />
                            <label htmlFor="in">{getLabel(OrdenesVentasLang, 'orderAgent', config.language)}</label>
                        </span>
                        <span className="p-float-label mt-2">
                            <InputText
                                value={values.Terms}
                                onChange={(e) => handleInputChange(e, 'Terms')}
                                disabled style={{ width: '100%' }}
                            />
                            <label htmlFor="in">{getLabel(OrdenesVentasLang, 'InventoryTerms', config.language)}</label>
                        </span>
                        <span className="p-float-label mt-2">
                            <InputText
                                value={values.PaymentTerm}
                                onChange={(e) => handleInputChange(e, 'PaymentTerm')}
                                disabled style={{ width: '100%' }}
                            />
                            <label htmlFor="in">{getLabel(OrdenesVentasLang, 'PaymentTerm', config.language)}</label>
                        </span>

                    </div>

                    <div className='d-flex flex-column'>
                        <span className="p-float-label mt-2">
                            <InputText
                                value={values.OrderType}
                                style={{ width: '100%' }}
                                disabled
                            />
                            <label htmlFor="in">{getLabel(OrdenesVentasLang, 'OrderType', config.language)}</label>
                        </span>
                        <span className="p-float-label mt-2">
                            <Calendar value={new Date(values.OrderDate)} style={{ width: '100%' }} showIcon disabled />
                            <label htmlFor="in">{getLabel(OrdenesVentasLang, 'OrderDate', config.language)}</label>
                        </span>

                        <span className="p-float-label mt-2">
                            <Calendar value={new Date(values.RequiredDate)} style={{ width: '100%' }} showIcon disabled />
                            <label htmlFor="in">{getLabel(OrdenesVentasLang, 'RequiredDate', config.language)}</label>
                        </span>
                        <div className='d-flex flex-column'   >
                            <div className='d-flex flex-row pt-2' style={{ justifyContent: 'space-between' }} >
                                <InputText value={values.IdPercent} style={{ width: '100%' }} />  <InputText value={values.MaxPercent} style={{ width: '100%' }} disabled />
                            </div>
                        </div>
                    </div>
                    <div className='d-flex flex-column' style={{ marginTop: -11 }}>
                        <Card
                            titulo={getLabel(OrdenesVentasLang, 'Adds', config.language)}
                            contenido={
                                <div className='d-flex flex-column pb-2'>
                                    <span className='columns2' >
                                        <label>{getLabel(OrdenesVentasLang, 'Brand', config.language)}</label>
                                        <InputText
                                            value={values.Brand} disabled
                                            style={{ width: '90%' }} />
                                    </span>
                                    <span className='columns2'>
                                        <label>{getLabel(OrdenesVentasLang, 'Depto', config.language)}</label>
                                        <InputText
                                            value={values.Depto} disabled
                                            style={{ width: '90%' }} />
                                    </span>
                                    <span className='columns2'>
                                        <label>{getLabel(OrdenesVentasLang, 'ISD', config.language)}</label>
                                        <InputText
                                            value={values.ISD} disabled
                                            style={{ width: '90%' }} />
                                    </span>
                                    <span className='columns2'>
                                        <label>{getLabel(OrdenesVentasLang, 'Season', config.language)}</label>
                                        <InputText
                                            value={values.Season} disabled
                                            style={{ width: '90%' }} />
                                    </span>
                                    <span className='columns2'>
                                        <label>{getLabel(OrdenesVentasLang, 'Program', config.language)}</label>
                                        <InputText
                                            value={values.Program} disabled
                                            style={{ width: '90%' }}
                                        />
                                    </span>

                                </div>}
                        />


                    </div>
                    <div>

                        <span className="p-float-label mt-2">
                            <InputTextarea
                                value={values.Comments} disabled
                                cols={50} rows={5} />
                            <label htmlFor="in">{getLabel(OrdenesVentasLang, 'ComentarioGeneral', config.language)}</label>
                        </span>
                        <Card
                            titulo={getLabel(OrdenesVentasLang, 'Revisado', config.language)}
                            contenido={<div className='d-flex flex-row' style={{ alignItems: 'center' }}>
                                <div className='d-flex flex-row'>
                                    <span className='d-flex flex-row mt-2'>
                                        <Checkbox checked={values.Revised} disabled />
                                        <label className='mx-2'>
                                            {getLabel(OrdenesVentasLang, 'Revisado', config.language)}
                                        </label>

                                    </span>
                                    <span>
                                        <InputText style={{ width: '100%' }} disabled />
                                    </span>
                                </div>

                            </div>}
                        />
                    </div>

                </div>
                <div >
                    <div className='d-flex flex-row'>
                        <Button icon='pi pi-refresh' onClick={() => ObtenerInformacion()} loading={loading} />
                        <Button icon='pi pi-save' onClick={() => GuardarInformacion()} className='mx-2' />
                    </div>
                </div>

                <div className='pt-2' style={{ height: '30vh' }}>
                    <AgGrid table={table} />
                </div>
                <div className='' style={{ height: '35vh' }}>
                    <AgGrid table={tablePC} />
                </div>
            </div>
        </Dialog>
    )
}

export default SalesOrdersCRUD